import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ContentComponent } from './content/content.component';
import { ContentDirective } from './content/content.directive';
import { ContentParsePipe } from './parse-content/parse-content.pipe';
import { RendererModule } from './renderers/renderer.module';
import { ContentRendererModule } from './renderers/content-renderer.module';
import { ParseHtmlPipe } from './parse-content/parse-html.pipe';

const DECLARATIONS = [
  ContentComponent,
  ContentDirective,
  ContentParsePipe,
  ParseHtmlPipe,
];

@NgModule({
  declarations: DECLARATIONS,
  imports: [CommonModule, RendererModule, ContentRendererModule],
  exports: [ContentRendererModule, ...DECLARATIONS],
})
export class ResourceContentUiModule {}
